<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green contentCenter">
            <h2 class="title text-center title-align">固碳幫手</h2>
            <div class="contentCenter">
                <p class="carbon-text-sm">
                    在綠川、柳川周圍的樹木們，不僅是鳥兒的休息站、遮蔭的好夥伴，更可以協助吸收碳排放，是地球的固碳幫手！<br>快來找找河川附近有哪些固碳幫手吧！
                </p>
                <select v-model="selectTree" class="selectStyle">
                    <option v-for="(tree, index) in treeList" :key="index" :value="tree">{{ tree }}</option>
                </select>
            </div>
            <div v-for="(helper, index) in helpers" :key="index">
                <div v-if="selectTree === helper.treeName">
                    <HelperResult :imgUrl="helper.imgUrl" :ability="helper.ability" :treeType="helper.treeType"
                        :category="helper.category" :introduction="helper.introduction" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import HelperResult from '@/components/HelperResult';

export default {
    data() {
        return {
            selectTree: '楓香',
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            treeList: [
                '楓香', '光蠟樹', '樟樹',
            ],
            helpers: [
                {
                    id: 1,
                    treeName: '楓香',
                    imgUrl: require('@/assets/liquidambar.jpg'),
                    ability: {
                        content: '楓香樹平均單株每年固碳量大約為7.4kg',
                        additional: '(但樹木的固碳量會依照樹木的年齡、生長環境、氣候條件等等因素而有所差異喔！)',
                    },
                    treeType: '楓香',
                    category: '落葉大喬木',
                    introduction: '楓香樹的葉子大多分成三瓣，秋天會變成紅色，但如果氣溫驟降，有可能來不及變紅就會掉落。楓香的果實為圓球形的多花聚合果，但因為果實掉落在地上時種子常已飛散，使果實呈現許多小空室，所以中藥稱楓果為「路路通」。楓香也是世界上遺存至今最古老的樹種之一喔！',
                },
                {
                    id: 2,
                    treeName: '光蠟樹',
                    imgUrl: require('@/assets/lightWaxTree.jpg'),
                    ability: {
                        content: '光蠟樹平均單株每年固碳量大約為5.6kg',
                        additional: '(但樹木的固碳量會依照樹木的年齡、生長環境、氣候條件等等因素而有所差異喔！)',
                    },
                    treeType: '光蠟樹',
                    category: '大型半落葉喬木',
                    introduction: '光臘樹為臺灣特有種，因為木材具有油亮的光澤，彷彿打上一層蠟一般，因此得名。光蠟樹樹姿優美，結果期時會有一個個長線形的翅果掛在樹上隨風飄曳，令人賞心悅目，樹液則是獨角仙成蟲喜愛的食物喔！',
                },
                {
                    id: 3,
                    treeName: '樟樹',
                    imgUrl: require('@/assets/camphorTree.jpg'),
                    ability: {
                        content: '樟樹平均單株每年固碳量大約為7.3kg',
                        additional: '(但樹木的固碳量會依照樹木的年齡、生長環境、氣候條件等等因素而有所差異喔！)',
                    },
                    treeType: '樟樹',
                    category: '常綠喬木',
                    introduction: '樟樹是長壽的樹種，而且全樹都有用處，根、木材、枝、葉均可提煉大家熟知的樟腦、樟腦油，如果揉搓樟樹的葉子，就可以聞到樟腦的辛香味喔！',
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
        HelperResult,
    },
    mixins: [coreMixin],
};
</script>

<style lang="sass" scoped>
.selectStyle
    width: 100%
select
  border: 1px solid #ACACAC
  color: #7F7F7F
  border-radius: 4px
  padding: 6px 10px
  background-color: #fff
  font-size: 16px
  transition: border-color 0.3s ease

select:focus
  border-color: #333
</style>
